
/* CalvoraCare PDP — Interactions */
(function() {
  'use strict';

  // Bundle selector
  function initBundleSelector() {
    var bundles = document.querySelectorAll('.pdp-bundle');
    var ctaBtn = document.querySelector('.pdp-hero__cta');
    var heroImg = document.querySelector('.pdp-hero__image-wrap img');
    
    bundles.forEach(function(bundle) {
      bundle.addEventListener('click', function() {
        bundles.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        
        // Update CTA price
        if (ctaBtn) {
          var price = this.getAttribute('data-price');
          var variantId = this.getAttribute('data-variant-id');
          ctaBtn.textContent = 'Pre-Order Now — $' + price;
          ctaBtn.setAttribute('data-variant-id', variantId);
        }
        
        // Update image
        if (heroImg) {
          var img = this.getAttribute('data-image');
          if (img) heroImg.src = img;
        }
      });
    });
    
    // CTA click — add to cart
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = this.getAttribute('data-variant-id');
        if (variantId) {
          // Add to cart via Shopify AJAX API
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            window.location.href = '/cart';
          })
          .catch(function(err) {
            console.error('Add to cart error:', err);
            window.location.href = '/cart';
          });
        }
      });
    }
  }

  // FAQ accordion
  function initFAQ() {
    var items = document.querySelectorAll('.pdp-faq__item');
    items.forEach(function(item) {
      var question = item.querySelector('.pdp-faq__question');
      if (question) {
        question.addEventListener('click', function() {
          var wasOpen = item.classList.contains('open');
          // Close all
          items.forEach(function(i) { i.classList.remove('open'); });
          // Toggle current
          if (!wasOpen) item.classList.add('open');
        });
      }
    });
  }

  // Ingredient accordion
  function initIngredients() {
    var items = document.querySelectorAll('.pdp-ingredient');
    items.forEach(function(item) {
      var header = item.querySelector('.pdp-ingredient__header');
      if (header) {
        header.addEventListener('click', function() {
          var wasOpen = item.classList.contains('open');
          items.forEach(function(i) { i.classList.remove('open'); });
          if (!wasOpen) item.classList.add('open');
        });
      }
    });
  }

  // Sticky bar
  function initStickyBar() {
    var hero = document.querySelector('.pdp-hero');
    var sticky = document.querySelector('.pdp-sticky');
    if (!hero || !sticky) return;
    
    var stickyBtn = sticky.querySelector('.pdp-sticky__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('visible');
        } else {
          sticky.classList.add('visible');
        }
      });
    }, { threshold: 0 });
    
    observer.observe(hero);
  }

  // Scroll animations
  function initAnimations() {
    var elements = document.querySelectorAll('.pdp-animate');
    if (!elements.length) return;
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.animationDelay = (entry.target.dataset.delay || '0') + 's';
          entry.target.classList.add('pdp-animate--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    
    elements.forEach(function(el) { observer.observe(el); });
  }

  // Init all
  document.addEventListener('DOMContentLoaded', function() {
    initBundleSelector();
    initFAQ();
    initIngredients();
    initStickyBar();
    initAnimations();
  });
})();
